import { Invoice } from 'entities';

export function sortByCurrency(a: Invoice, b: Invoice): number {
  const [aMonetary, bMonetary] = [a, b].map(({ currency, value }) => ({
    currency,
    value,
  }));

  if (aMonetary.currency !== bMonetary.currency)
    return aMonetary.currency.localeCompare(bMonetary.currency);

  const [valueA, valueB] = [aMonetary.value, bMonetary.value].map(Number);

  return valueA - valueB;
}
